/**
 * KlantlinkKopieren — kopieert de publieke foto-timeline van één kleed.
 *
 * De link (`client.kleda.nl/fotos/{token}`) is wat de klant straks in zijn mail
 * krijgt zodra `MEDIA_KLANTLINK_EIGEN` aangaat. Vóór die flip bestaat de pagina
 * al en is de URL al af te leiden, want het token is een stateless HMAC over het
 * WI-id. Daarom kan kantoor hem nu al delen aan de telefoon, zonder dat er iets
 * gebackfilld hoeft te zijn.
 *
 * Bewust naast de CompanyCam-link in plaats van eroverheen: tot de flip is
 * CompanyCam nog de link die in de klantmails staat, en die twee moeten in deze
 * periode uit elkaar te houden zijn.
 */
import { useState } from 'react';

export function KlantlinkKopieren({ url }: { url: string }) {
  const [gekopieerd, setGekopieerd] = useState(false);

  const kopieer = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setGekopieerd(true);
      setTimeout(() => setGekopieerd(false), 1500);
    } catch {
      /* geen clipboard-permissie: de link blijft via 'openen' bereikbaar */
    }
  };

  return (
    <div className="flex items-center gap-3">
      <button
        type="button"
        onClick={kopieer}
        title="Kopieer de link die de klant te zien krijgt"
        className="inline-flex items-center gap-1.5 rounded-md bg-indigo-600 px-2.5 py-1.5 text-xs font-medium text-white hover:bg-indigo-700"
      >
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m11.25 2.25h-3.375c-.621 0-1.125-.504-1.125-1.125V4.125"
          />
        </svg>
        {gekopieerd ? 'Gekopieerd' : 'Kopieer klantlink'}
      </button>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="text-xs text-indigo-600 hover:underline"
      >
        Bekijken zoals de klant ↗
      </a>
    </div>
  );
}
